module.exports = "/_next/static/images/618a9092df960d7d9f2c21fa2cb5015d-app-screenshots-xs@1x.jpg.webp";